import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function CVMP2023() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>Enhanced Illumination Adjustment in 3D Outdoor Reconstructions via Shadow Removal through Color Transfer</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 18 - 19, 2024.</BlockSubtitle>
          <BlockText>Herbert Potechius, Selvam Essaky, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>The introduction of 3D reconstruction technology has revolutionized the digitization of real-world objects, from small artifacts to large-scale structures like buildings. This technology enables the rapid creation of virtual representations of the real world with minimal design expertise, offering a novel way to experience reality. However, it presents challenges such as baked-in illumination, which complicates subsequent relighting and integration into digital environments. This paper introduces a shadow removal algorithm, <i>SRCT</i>, that uses simulated lighting and color transfer techniques to reduce the visible effects of self- and cast shadows in the texture maps of 3D models resulting from the 3D reconstruction process. The effectiveness of this approach is validated through a comparison with existing shadow removal techniques. This validation utilizes a newly introduced dataset, <i>EDEN</i>, which comprises 3D reconstructions of buildings derived from drone imagery for qualitative evaluation, along with an additional dataset, <i>Sunlit3D</i>, featuring 3D reconstructions of buildings under various simulated lighting conditions for quantitative analysis.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="240px 240px 240px 240px 240px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://dl.acm.org/doi/10.1145/3697294.3697308")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://dl.acm.org/doi/10.1145/3697294.3697308")}>arXiv</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://github.com/hpotechius/ShadowRemovalColorTransfer")}>Code</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Datasets/Sunlit3D')}>Dataset 1</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Datasets/EDEN1')}>Dataset 2</BlockButton>
        </BlockContent>
        {/* <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => navigate('/Projects/Datasets/CTPublication')}>Code</BlockButton>
        </BlockContent> */}
      </Block>



      <Footer/>
    </div>
  );
}

export default CVMP2023;
